var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 23.5448V26.6667C13.3327 28.1394 14.5266 29.3333 15.9993 29.3333C17.4721 29.3333 18.666 28.1394 18.666 26.6667V23.5448M15.9993 2.66667V4.00001M3.99935 16H2.66602M7.33268 7.33334L6.53255 6.53321M24.666 7.33334L25.4663 6.53321M29.3327 16H27.9993M23.9993 16C23.9993 20.4183 20.4176 24 15.9993 24C11.5811 24 7.99935 20.4183 7.99935 16C7.99935 11.5817 11.5811 8.00001 15.9993 8.00001C20.4176 8.00001 23.9993 11.5817 23.9993 16Z",
    stroke: "#525252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.8967e8fbf0ea92da323876e6e4dbce8c.svg";
export { ForwardRef as ReactComponent };